var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-article-list"},[_c('article-filters'),_c('article-filter-remover'),_c('article-sort'),_c('article-message'),_c('article-items')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }